import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { VolumeEstimatorGoalSetting } from '../interfaces/volume-estimator-goal-setting';
import { VolumeEstimatorTarget } from '../interfaces/volume-estimator-target';

@Injectable({
    providedIn: 'root',
})
export class VolumeEstimatorService {
    constructor(private _http: HttpClient) {}

    calculateGoalTarget(goal: VolumeEstimatorGoalSetting): Observable<VolumeEstimatorTarget> {
        return this._http.get<VolumeEstimatorTarget>(
            `https://${window.location.host}/api/v0.5/tools/LoanVolumeGoalTargetGet/${goal.annualCompensationTarget}/${goal.averageLoanAmount}/${goal.averageCommissionBps}/${goal.leadToFundPullThru}`
        );
    }
}
